import { normalizePlate } from "./plates"

const MAP: Record<string, string> = {
  GDA73308: "PO3YW58",
  GDA73309: "PY4649Y",
  FG5564P: "FZ3672Y",
  WPR5802T: "PO5YW81",
  WPR8057T: "PZ4U211",
  WPR5928T: "PY3217Y",
  WPR9051T: "NOL75K4",
  WPR9052T: "WGM3616R",
  GDA88195: "PY0286Y",
  PZ5A856: "NO204AL",
  PNT98284: "PY1044Y",
  PZ3U897: "PY0288Y",
  PY65516: "PY2394Y",
  WPR5926T: "WGM3633R",
  FG5565P: "FZ2869Y",
  PZ401SH: "PZ4N711",
  WGM1723F: "PZ4N830",
  WGM1718F: "PY1764Y",
  PZ598UP: "PY2850Y",
  WPR3963P: "PY3442Y",
  WPR1353T: "PNTPN95",
  WGM8412G: "NOL42K3",
  PO9NT49: "PNTRF23",
  WGM1918G: "WZ979FC",
  WPR6810P: "PO1YX59",
  WGM8411G: "NOL44K3",
  PZ2C523: "WZ980FC",
  GDA77173: "PY0285Y",
  WPR7891P: "PZ4N714",
  PO4TG22: "FZ2087Y",
  WGM3457F: "PY0474Y",
  PNT98285: "PNTRF19",
  WGM2XT2: "GDA99160",
  WPR7892P: "PY2910Y",
  WPR3067P: "PZ4U001",
  PY24927: "GDA99159",
  WPR6822P: "NOL54F4",
  PY08546: "WZ459GE",
  WGM9707A: "PZ4N722",
  PO9NT50: "KK5849P",
  WGM17346: "PY1763Y",
  WPR9150P: "PZ188WT",
  PZ479XN: "PY0617Y",
  WPR7889P: "PNTRF20",
  WPR1802T: "PZ4U214",
  WZ209GP: "PZ4N718",
  WGM6044H: "NOL94H9",
  WPR1619T: "PZ4U212",
  PZ3U775: "PZ6V093",
  FG5566P: "PZ4N719",
  WZ682FP: "PY0013Y",
  GDA77172: "PNTPR28",
  WZ210GP: "PZ4U220",
  NOL6708E: "NOL82K2",
  PY76795: "PY1259Y",
  WPR3425T: "PY2397Y",
  GDA88194: "PY0472Y",
  WZ208GP: "FZ2091Y",
  PY24556: "PY2398Y",
  PY31452: "PZ4P074",
  FG5567P: "PZ4U009",
  WGM14304: "WND47H7",
  WPR1617T: "PO7YW72",
  PZ112UP: "PZ4P073",
  PZ545UP: "PZ4P065",
  WPR6494P: "PZ4U003",
  WPR4994P: "PY1045Y",
  WPR0236T: "FZ2133Y",
  PZ3P023: "PZ4U217",
  PZ3P082: "PZ3X115",
  PGO43970: "PZ4N715",
  PNT91354: "PO9YW75",
  WGM7327H: "WWL6033T",
  WPR2594T: "WZ456GE",
  GDA57197: "PZ4U216",
  WZ423FP: "PY0667Y",
  WZ533FR: "FZ3091Y",
  GDA57175: "WZ981FC",
  PZ3U332: "WZ544GE",
  WGM6657G: "NO202AL",
  PGO43884: "PZ3X119",
  PNT91355: "PO9YW73",
  PGO45170: "FZ3090Y",
  FG2146P: "PZ189WT",
  WGM1630F: "PY3267Y",
  WGM9706A: "PZ4N717",
  WZ677FL: "PO3YW60",
  WZ683FP: "PZ2K472",
  GDA57188: "PY4050Y",
  GDA81674: "PZ6V095",
  NOL6322E: "PO8XY72",
  WGM3510F: "FZ2712Y",
  WPR6496P: "PO6YS35",
  WPR3646P: "PY6106Y",
  WGM14387: "PY1297Y",
  FG2142P: "NOL81K2",
  WGM3359K: "WND48H7",
  NOL6325E: "NO373AL",
  WPR1355T: "PO5YJ32",
  WPR6809P: "WGM3617R",
  FG2150P: "FZ3679Y",
  PY23651: "PY5745Y",
  GDA81673: "KK5850P",
  WZ676FL: "PY0923Y",
  WPR5810T: "PZ6V094",
  WPR5927T: "WND46H7",
  PZ2C521: "FZ2719Y",
  PY11671: "PY4344Y",
  WPR3964P: "NOL83K2",
  PY35602: "PZ4N716",
  WPR4898T: "PY2901Y",
  PY23605: "WZ543GE",
  PY24926: "WND49H7",
  PY35023: "PNTPN96",
  PY39161: "PY0924Y",
  FZ8074T: "PO3YW59",
  WGM3356K: "NO363AL",
  WPR8056T: "PNTPU85",
  WGM1719F: "PZ3X118",
  WPR1352T: "FZ2713Y",
  GDA73221: "PO9YW80",
  WGM1721F: "PY4619Y",
  PZ544UP: "PZ769MC",
  GDA73306: "PY1261Y",
  GDA77034: "PY4636Y",
  PZ3U027: "PO8XY87",
  WPR6498P: "PO7YW90",
  FG2149P: "PO9YX47",
  PY35603: "PY3263Y",
  PZ069TL: "NOL48K3",
  PY25245: "PY2866Y",
  GDA84167: "PY7591Y",
  GDA86715: "PO8XY71",
  PNT91965: "NOL69K1",
  PZ2C522: "NO203AL",
  WZ567FN: "PO5Y941",
  WPR3404T: "PY0287Y",
  FG5563P: "FZ2685Y",
  GDA84168: "PY7168Y",
  WGM17152: "PY2164Y",
  GDA68700: "PY2749Y",
  PZ2U811: "NOL49K3",
  WPR0235T: "PY4951Y",
  WGM1632F: "PO7YM43",
  WPR0237T: "PO7YW93",
  WZ207GP: "WZ458GE",
  PZ2C524: "PZ655UT",
  WZ681FP: "PY8105Y",
  WZ398GR: "WND25H7",
  FG5568P: "PY2750Y",
  WPR3068P: "PY2909Y",
  WPR5830P: "PY2246Y",
  WPR8388N: "NO215AL",
  WPR1803T: "PO5Y862",
  PZ5A780: "PZ4U213",
  WPR9149P: "FZ2861Y",
  WGM1917G: "PZ2K468",
  WPR3251T: "PNTRF17",
  NOL6323E: "PY2423Y",
  NOL6320E: "PY0475Y",
  WPR3765P: "PY3265Y",
  PY35325: "PY1779Y",
  PY35606: "NOL50K3",
  PNT91356: "PO6YW40",
  WGM77644: "NOL45K3",
  FG5570P: "PNTPU84",
  WPR3647P: "PY7167Y",
  PY25246: "PNTTF05",
  WGM3358K: "PY3209Y",
  PNT98283: "PZ4U219",
  WPR4995P: "WND26H7",
  PO8TF53: "PZ3X121",
  WPR6497P: "PZ4N712",
  PZ720ME: "PZ4N720",
  PNT0059A: "PY4952Y",
  GDA71375: "PZ3X120",
  PY22505: "PO5YW84",
  GDA67563: "FZ2132Y",
  PY11670: "NO365AL",
  FG2147P: "PZ4P070",
  PY35605: "PY1765Y",
  PY35802: "PZ3X116",
  WPR3252T: "NO205AL",
  NOL6319E: "WGM3590R",
  WZ696FN: "PZ4N721",
  WGM3357K: "PO5YW85",
  GDA88167: "PO9YX46",
  PZ676UP: "PO7YW73",
  PO1SH79: "FZ2088Y",
  PY36214: "PO1YX60",
  FG5571P: "PZ4P066",
  PY35303: "PZ4N832",
  WPR3814P: "PO5YJ36",
  PZ113UP: "FZ2130Y",
  WPR1356T: "PO5Y861",
  PY22506: "PY1766Y",
  WPR5929T: "PY2326Y",
  PNT91964: "PNTRF18",
  WPR4716P: "NOL74K4",
  WGM14042: "PY1295Y",
  WGM11325: "PO5YW83",
  EKU07072: "PY2911Y",
  WGM3019F: "WZ960FC",
  WPR1801T: "PY8106Y",
  WPR4742P: "PY2367Y",
  WGM1920G: "PO9YW68",
  WGM0595H: "WZ882FC",
  WGM3509F: "NOL73K3",
  WGM86550: "NOL95H9",
  WPR4743P: "KK5851P",
  GDA58370: "PY7170Y",
  PZ2K727: "PO4YJ03",
  WZ397GR: "PO9YX44",
  PZ754TT: "WZ493GE",
  GDA56775: "WZ460GE",
  FZ0367S: "PY1778Y",
  WPR0238T: "PO8XY86",
  FG5562P: "PO5YJ33",
  GDA76143: "NOL43K3",
  GDA79575: "NOL76K4",
  WPR3645P: "PY2399Y",
  WZ206GP: "PY3264Y",
  GDA68862: "NOL93H9",
  NOL6324E: "PO7YV40",
  PNT91357: "PY1043Y",
  PNT98286: "PY1625Y",
  GDA79574: "WZ542GE",
  FG2141P: "PZ4N723",
  PY09732: "PY2904Y",
  PNT91352: "PO7YW91",
  WGM1722F: "PO7YV39",
  PZ344SP: "WZ458GE",
  PZ3U798: "PY4617Y",
  WPR5378P: "PY1784Y",
  WPR5932T: "PY1296Y",
  PNT0053A: "PY2905Y",
  PY09780: "NOL46K3",
  PNT91353: "PY1116Y",
  WPR1189T: "PO7YW76",
  WGM17117: "PNTPY71",
  WGM0594H: "PY3401Y",
  WGM7326H: "PZ4P072",
  WPR4142T: "PO9YX75",
  WPR5399T: "PY7172Y",
  WZ396GR: "PO1YU23",
  WPR9636T: "PY0473Y",
  WGM6043H: "FZ2087Y",
  PZ3P024: "PNTRF24",
  WGM3020F: "PZ4P067",
  WPR3965P: "PY1624Y",
  GDA68861: "PY0101Y",
  WPR1354T: "PZ4P068",
  WPR1618T: "PY7592Y",
  PY23652: "PO9YX45",
  PY24925: "PO8XY85",
  FG5569P: "PZ4P075",
  PY35801: "PNTRU12",
  WPR4829T: "PY6058Y",
  NOL6709E: "FZ3680Y",
  PNT0052A: "PZ4N713",
  PY08547: "PO4YJ08",
  PZ2U808: "PY3301Y",
  WGM3352K: "NO364AL",
  NOL6318E: "PO7YV38",
  WPR3766P: "PO7YW92",
  WGM1720F: "PZ4P071",
  WZ680FP: "PO5YJ22",
  PY35604: "PY1780Y",
  PNT0057A: "PO9YW78",
  NOL6321E: "PY2365Y",
  PZ4A032: "PY7169Y",
  PNT0058A: "PZ039YM",
  PY20912: "PZ4N829",
  GDA73307: "PY4048Y",
  PZ3U334: "PY2903Y",
  FG2148P: "NO366AL",
  WZ205GP: "PZ191WT",
  PY11672: "WZ457GE",
  WGM7328H: "FZ3657Y",
  PNT91963: "PY2245Y",
  WZ532FR: "PY0663Y",
  WPR4794P: "PY3210Y",
}

export function lookupTrailer(truckPlate: string): string | undefined {
  const key = normalizePlate(truckPlate)
  return MAP[key]
}
